import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../servicios/api.service';
import { environment } from '../../../environments/environment'
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-app-encabezadoLogos',
  templateUrl: './app-encabezadoLogos.component.html',
  styleUrls: ['./app-encabezadoLogos.component.scss']
})
export class AppEncabezadoLogosComponent implements OnInit {

  // public mainNavbar: any;
  public windowHeight: any;
  // public showMenu: boolean;
  public legislatura;
  public legislaturas;
  public nombreLogo: any;
  public IMAGENESROUTE = environment.imagenes;
  private legislaturaChanges$: Subscription = null;
  constructor(private _api: ApiService) { }

  ngOnInit() {
    this.legislatura = this._api.getLegislatura();
    if (this.legislatura) {
      this.obtenerLogotipo(this.legislatura.idlegislatura);
    } else {
      this._api.get('actualLegislatura').subscribe(actualLegislatura => {
        let l = this._api.reader.read(actualLegislatura, [{}])[0];
        this._api.setLegislatura(l);
        this.obtenerLogotipo(l.idlegislatura);
      })
    }
    this._api.get('legislaturas').subscribe(response => {
      this.legislaturas = this._api.reader.read(response, []);
    })

    // this.mainNavbar = $('.onepage .header_area.navbar');
    this.windowHeight = $(window).height()

    this.MenuLineHeight();


    $(window).resize(() => {
      this.MenuLineHeight();
      // this.revisarMobile();
    });

  }

  ngOnDestroy() {
    // Eliminar suscripción del evento al cambiar legislatura
    this.legislaturaChanges$.unsubscribe();
  }

  // funcion para revisar si el mobille y poner el logo
  // private revisarMobile() {
  //   let windowWidth = $(window).width();
  //   let windowHeight = $(window).height();
  //   let isMobile = windowWidth < 768;

  //   setTimeout(() => {
  //     isMobile ? $('.mean-bar').prepend(`<a href="/"><img id="imgLogoCongreso" alt="H. Congreso del Estado de Yucatán" src="${this.IMAGENESROUTE + this.nombreLogo.valor}"></a>`) : null;
  //   }, 500);
  // }


  /**
   * LLama al API para obtener el nombre
   *  de la imagen que se va a mostrar
   * en el navbar
   */
  public obtenerLogotipo(idLegislatura) {
    this._api.get(`logo-legislatura/${idLegislatura}`).subscribe(response => {
      this.nombreLogo = this._api.reader.read(response, [{}])[0];
      setTimeout(() => {
        this.MenuLineHeight();
      }, 100);
    })
  }

  //Menu Line Height
  public MenuLineHeight() {
    var windowWidth = $(window).width();
    var menuLineHeight = windowWidth * 0.05625;
    $('.navbar-nav > li > a, .logo_area > a').css('line-height', menuLineHeight + 'px');
  }

  public setLegislatura(l) {
    // Establece la legislatura en el servicio del API
    if (l) {
      this.legislatura = l;
      this._api.setLegislatura(l);
    }

  }

}